package net.gorillagroove.review

import net.gorillagroove.util.Instant
import net.gorillagroove.api.ReviewSourceId
import net.gorillagroove.api.UserId
import net.gorillagroove.db.DbReviewSource
import net.gorillagroove.sync.OfflineAvailabilityType


class ReviewSource(
    val id: ReviewSourceId,
    val sourceType: ReviewSourceType,
    val displayName: String,
    val offlineAvailability: OfflineAvailabilityType,
    val updatedAt: Instant,
    val sourceUserId: UserId?
)

internal fun DbReviewSource.toReviewSource() = ReviewSource(id, sourceType.asEnumeratedType(), displayName, offlineAvailability.asEnumeratedType(), updatedAt, sourceUserId)
